import React from 'react';
import { User, MapPin, Mail, Phone, Github } from 'lucide-react';

const About = ({ data, language, translations }) => {
  const profileData = data || JSON.parse(localStorage.getItem('portfolioData') || '{}');
  const t = translations || {};

  return (
    <div className="content-section">
      <h2 className="section-title">{t.aboutMe || 'Sobre mí'}</h2>
      <div className="section-content">
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '20px', flexWrap: 'wrap' }}>
          {profileData.logo && (
            <img
              src={profileData.logo}
              alt="C4sh3r logo"
              data-testid="about-c4sh3r-logo"
              style={{
                width: '96px',
                height: '96px',
                borderRadius: '12px',
                border: '1px solid var(--steel-line-strong)',
                boxShadow: '0 0 24px rgba(176, 107, 255, 0.16)',
                objectFit: 'cover',
                flexShrink: 0
              }}
            />
          )}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <User size={24} color="var(--steel-dim)" />
            <h3 style={{ color: 'var(--steel-bright)', fontSize: '20px', margin: 0 }} data-testid="about-name-heading">
              {profileData.name}
            </h3>
          </div>
        </div>
        
        <p style={{ fontSize: '18px', color: 'var(--text-secondary)', marginBottom: '15px' }}>
          {t.title || profileData.title}
        </p>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
          <MapPin size={18} color="var(--steel-dim)" />
          <span>{t.location || profileData.location}</span>
        </div>

        <div style={{ whiteSpace: 'pre-line', lineHeight: '1.8', marginTop: '20px' }}>
          {t.about || profileData.about}
        </div>

        <div style={{ marginTop: '30px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          <div style={{ background: 'var(--bg-tertiary)', padding: '15px', borderRadius: '8px', border: '1px solid var(--border-color)' }}>
            <Mail size={20} color="var(--steel-dim)" style={{ marginBottom: '10px' }} />
            <p style={{ fontSize: '14px', opacity: '0.8' }}>Email</p>
            <p style={{ color: 'var(--steel)' }}>{profileData.email}</p>
          </div>
          <div 
            style={{ background: 'var(--bg-tertiary)', padding: '15px', borderRadius: '8px', border: '1px solid var(--border-color)', cursor: 'pointer', transition: 'all 0.3s ease' }}
            onClick={() => window.open(profileData.github, '_blank', 'noopener,noreferrer')}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'var(--cyan-primary)';
              e.currentTarget.style.boxShadow = '0 0 15px var(--cyan-dim)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'var(--border-color)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <Github size={20} color="var(--steel-dim)" style={{ marginBottom: '10px' }} />
            <p style={{ fontSize: '14px', opacity: '0.8' }}>GitHub</p>
            <p style={{ color: 'var(--steel)', fontSize: '13px' }}>{profileData.githubUsername}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
